import React from 'react';
import { Edit2 } from '@myua/icons/dist/bulk16';
import * as sharingLinkActions from '../actions';
import { Button } from '@myua/kit';
import { useSelector, useDispatch } from 'react-redux';
import { getSelectedIds, getLinksById } from '../selectors';

export const EditButton = () => {
  const dispatch = useDispatch();
  const selectedIds = useSelector(getSelectedIds);
  const linksById = useSelector(getLinksById);
  const link = linksById[selectedIds[0]];

  return (
    <Button
      title="Edit"
      className="al-btn-blue-icon"
      disabled={selectedIds.length !== 1}
      onClick={
        link
          ? () => dispatch(sharingLinkActions.linkModalSetVisible({ visible: true, link }))
          : undefined
      }
      icon={<Edit2 />}
    >
      Edit
    </Button>
  );
};
